// AUTO-GENERATED - DO NOT EDIT MANUALLY
// Generated from App\Controller\Dto\Response\AgendaSettingResponse

import { AgendaTitleDisplay, AgendaPaxDisplay, AgendaShowTimeslot, AgendaThirdRowDisplay, AgendaBackground, AgendaCashDisplay, AgendaBookingPreviewDisplay } from './enums.gen';

export type AgendaSettingApiResponse = {
	showGauge: boolean;
	titleDisplay: AgendaTitleDisplay;
	paxDisplay: AgendaPaxDisplay;
	showTimeslot: AgendaShowTimeslot;
	showCustomerRequest: boolean;
	showPrivateNote: boolean;
	showRemainingPayment: boolean;
	showOrigin: boolean;
	showOffer: boolean;
	thirdRowDisplay: AgendaThirdRowDisplay;
	background: AgendaBackground;
	cash: AgendaCashDisplay;
	displayBookingPreview: AgendaBookingPreviewDisplay;
};

export type AgendaSetting = {
	showGauge: boolean;
	titleDisplay: AgendaTitleDisplay;
	paxDisplay: AgendaPaxDisplay;
	showTimeslot: AgendaShowTimeslot;
	showCustomerRequest: boolean;
	showPrivateNote: boolean;
	showRemainingPayment: boolean;
	showOrigin: boolean;
	showOffer: boolean;
	thirdRowDisplay: AgendaThirdRowDisplay;
	background: AgendaBackground;
	cash: AgendaCashDisplay;
	displayBookingPreview: AgendaBookingPreviewDisplay;
};

export function hydrateAgendaSetting(data: AgendaSettingApiResponse): AgendaSetting {
	return { ...data };
}